import React from "react";
import { Box, Container, Typography } from "@mui/material";
import "./SellYourMusicSecondSection.scss";
import UnifiedButton from "../../shared/Button";
import MusicImage1 from "../../../assets/Images/Sell your music/Amplify your music with advanced.jpg";
import sellicon from "../../../assets/Images/Sell your music/Unlimited music sign.svg";
import sellicon1 from "../../../assets/Images/Sell your music/Unlimited music sign1.svg";
import instagram from '../../../assets/Images/Sell your music/The ultimate platform for artists & labels.jpg'
import { useNavigate } from "react-router-dom";

function SellYourMusicSecondSection() {

  const navigate = useNavigate(); // Initialize navigate

  // Common function to handle navigation
  const handleNavigation = (route) => {
    console.log(`Navigating to: ${route}`);
    navigate(route); // Navigate to the desired route
    window.scrollTo(0, 0); // Optional: Scroll to top
  };


  const handleGetStarted = () => {

    navigate("/support/legal-documents");

    window.scrollTo(0, 0);  // Scroll to top of the page
  };

  return (
    <Box className="sell-your-music">
      <div className="second-section">
        <Container className="text-content">
          <div style={{ maxWidth: "700px" }}>
            <img
              src={sellicon}
              alt="Music Studio"
              style={{ width: "60px", margin: "auto", display: "flex" }}
            />
            <Typography variant="h3" className="section-heading">
              Amplify your music with advanced distribution tools.
            </Typography>
            <Typography variant="h5">
              Seeking more than just free distribution?
            </Typography>
            <Typography variant="body1" className="section-description">
              Whether it's through creative tools, strategic releases, or
              industry connections, we’re here to support independent music at
              every step.
            </Typography>
            <Typography variant="body1" className="section-description">
              We partner with artists, labels, and managers to pave the way for
              a successful music career.
            </Typography>
          </div>
          {/* Distribution Tools List */}
          <div className="tools-grid">
            <div className="tool-card" onClick={() => handleNavigation('/')}>
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                  CRBT
                </Typography>
                <Typography sx={{ fontSize: "13px" }} variant="body1">
                  {" "}
                  Personalize your caller tunes with CRBT - share your music
                  with every call!
                </Typography>
              </div>
            <div className="tool-card" onClick={() => window.location.href = 'https://app.fmdigitalofficial.com/sign-in'}>
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                  YouTube Content ID
                </Typography>
                <Typography sx={{ fontSize: "13px" }} variant="body1">
                  {" "}
                  Protect your music and earn revenue with YouTube Content ID.
                </Typography>
              </div>
            <div className="tool-card" onClick={() => handleNavigation('/')}>
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                  Profile Linking
                </Typography>
                <Typography sx={{ fontSize: "13px" }} variant="body1">
                  {" "}
                  Integrate and manage your Meta (Facebook) profiles
                  effortlessly with Profile Linking.
                </Typography>
              </div>
            <div className="tool-card" onClick={() => handleNavigation('/')}>
                <Typography variant="h5" sx={{ fontWeight: "bold" }} >
                  Distribute Lyrics
                </Typography>
                <Typography sx={{ fontSize: "13px" }} variant="body1">
                  {" "}
                  Distribute your lyrics on streaming platforms to boost
                  visibility and increase revenue.
                </Typography>
              </div>
            <div className="tool-card" onClick={() => handleNavigation('/services/featured-playlists')} >
                <Typography variant="h5" sx={{ fontWeight: "bold" }}  >
                  Playlist Pitching
                </Typography>
                <Typography sx={{ fontSize: "13px" }} variant="body1">
                  {" "}
                  Pitch your music to playlists for enhanced visibility and
                  increased streaming revenue.
                </Typography>
              </div>
            <div className="tool-card" onClick={() => handleNavigation('/')}>
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                  Artist Management
                </Typography>
                <Typography sx={{ fontSize: "13px" }} variant="body1">
                  {" "}
                  Expertly manage and support your music career with tailored
                  artist management services for maximum growth and success
                </Typography>
              </div>
            <div className="tool-card" onClick={() => handleNavigation('/services/music-marketing')} >
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                  Marketing & Strategy
                </Typography>
                <Typography sx={{ fontSize: "13px" }} variant="body1">
                  {" "}
                  Elevate your music’s presence with our expert marketing and
                  strategy solutions, crafted to amplify your brand and impact.
                </Typography>
              </div>
            </div>
        </Container>

        <div className="image-wrapper">
          <img
            src={MusicImage1}
            alt="Music Studio"
            className="floating-image"
          />
        </div>
      </div>

      <div className="bottom-section">
        <div className="bottom-content">
          <img
            src={instagram}
            className="bottom-image"
            alt="Artist Collaboration"
            style={{ borderRadius: '30px' }}
          />
          <div className="text-content-bottom">
            <img
              src={sellicon1}
              alt="Music Studio"
              style={{ width: "60px", margin: "auto", display: "flex" }}
            />
            <Typography variant="h4">
              The ultimate platform for artists & labels.
            </Typography>
            <Typography variant="body2">
              We cover all your needs: distribution, marketing, & catalog
              management.
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <UnifiedButton
                variant="contained"
                className="cta-button"
                textContent={"Learn More"}
                onClick={handleGetStarted}
              />
            </Box>
          </div>
        </div>
      </div>
    </Box>
  );
}

export default SellYourMusicSecondSection;
